import { render, staticRenderFns } from "./tyyRevenueStatics.vue?vue&type=template&id=a36c10fa&"
import script from "./tyyRevenueStatics.vue?vue&type=script&lang=js&"
export * from "./tyyRevenueStatics.vue?vue&type=script&lang=js&"
import style0 from "./tyyRevenueStatics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports